import { makeStyles } from '@material-ui/core';
import { tcsmColors } from '../../theme-constants/colors';




export const institutionBarStyles = makeStyles((theme) => ({
    institutionBarContainer: {
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
        paddingTop: theme.spacing(.875),
        paddingBottom: theme.spacing(.875),
        
        background: tcsmColors.darkBlue,
      

        [theme.breakpoints.down('md')]: {
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2),
        },

        [theme.breakpoints.down('sm')]: {
            paddingLeft: theme.spacing(1),
            paddingRight: theme.spacing(1),
        },
        [theme.breakpoints.up('sm')]: {
            display: 'flex',
            alignItems: 'center',
        },
        '& *': {
            color: tcsmColors.white,
        },
        '& a': {
            '&:hover': {
                color: tcsmColors.white,
            },
        },
        '& .institution-bar': {
            '&-inner': {
                display: 'flex',
            },
   
            '&-number': {
                marginRight: theme.spacing(1),
            },
            '&-name': {
                marginRight: theme.spacing(1),
            },
        },
    },



}));



